import React, { Component } from "react";

import PortfolioImage from "./PortfolioImage";
import PortfolioImageCarousel from "./PortfolioImageCarousel";
import PortfolioTools from "./PortfolioTools";

import store from "../Store";

// CSS
import "./Portfolio.css";

const shuffle = require("lodash/shuffle");

export default class Portfolio extends Component {
	state = {
		labelsVisible: false,
		filteredImages: shuffle(store.data),
	};

	toggleLabels = () => {
		this.setState({ labelsVisible: !this.state.labelsVisible });
	};

	shuffleImages = () => {
		this.setState({
			filteredImages: shuffle(this.state.filteredImages),
		});
	};

	filterImages = filter => {
		filter = filter.toLowerCase();
		const filtered = store.data.filter(image => {
			return (
				image.tags
					.toString()
					.toLowerCase()
					.indexOf(filter) > -1 || image.name.toLowerCase().indexOf(filter) > -1
			);
		});

		this.setState({
			filteredImages: filtered,
		});
	};

	render() {
		const { loaderComplete } = this.props;

		const { labelsVisible, filteredImages } = this.state;

		let imageCarousels = -1;
		let images = -1;
		let all = -1;

		return (
			<div className="Portfolio">
				<PortfolioTools
					toggleLabels={this.toggleLabels}
					labelsVisible={labelsVisible}
					loaderComplete={loaderComplete}
					shuffle={this.shuffleImages}
					filter={this.filterImages}
				/>

				<div className="PortfolioThumbnails">
					{loaderComplete === true &&
						filteredImages.map(portfolioImage => {
							all += 1;
							if (portfolioImage.src.length === 1) {
								images += 1;
								return (
									<PortfolioImage
										key={portfolioImage.id}
										data={portfolioImage}
										index={images}
										indexAll={all}
										total={filteredImages.length}
										labelsVisible={labelsVisible}
									/>
								);
							} else {
								imageCarousels += 1;
								return (
									<PortfolioImageCarousel
										key={portfolioImage.id}
										data={portfolioImage}
										index={imageCarousels}
										indexAll={all}
										total={filteredImages.length}
										labelsVisible={labelsVisible}
									/>
								);
							}
						})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Portfolio.js